import * as React from 'react'
import styled from 'styled-components'
import { isMobile } from 'react-device-detect'
import AppStoreBadgeButtons from '@components/shared/AppStoreBadgeButtons'
import {
  colors,
  OutlineOnFocusVisible
} from '@components/shared'
import { DipseaBrandmark } from '@components/shared/icons'
import { config } from 'react-awesome-styled-grid'
import BackgroundGradient from '@components/BackgroundGradient'

export type PropsType = {
  header?: string,
  subheader1?: string,
  subheader2?: string,
  goHome?: () => void,
  showFooter?: boolean,
  hideBadges?: boolean,
  isFullScreen?: boolean
}

export default function PostSubContent (props: PropsType): React.ReactNode {
  const {
    header,
    subheader1,
    subheader2,
    goHome,
    showFooter,
    hideBadges,
    isFullScreen
  } = props

  return (
    <Container isFullScreen={isFullScreen}>
      <BackgroundImageContainer>
      <BackgroundGradient
        quadrant={1}
        gradientColor={colors.midnightBlue}
        gradientPosition='bottom'
      />
      </BackgroundImageContainer>

      <WelcomeContainer>
        <DipseaBrandmark size={56} borderRadius={8} />

        <Header isLarge={isFullScreen}>{header || 'Welcome to Dipsea'}</Header>

        <SubHeader isLarge={isFullScreen}>
          {subheader1 ||
            'You now have unlimited to hundreds of sexy stories, sleep scenes, and wellness sessions.'}
        </SubHeader>

        {!hideBadges && (
          <>
            <Divider isLarge={isFullScreen} />

            <SubHeaderAboveButton isLarge={isFullScreen}>
              {subheader2 || isMobile
                ? 'Download the app'
                : 'Listen on your phone'}
            </SubHeaderAboveButton>

            <BadgeWrapper>
              <AppStoreBadgeButtons />
            </BadgeWrapper>
          </>
        )}

        {showFooter && (
          <HomeLink onClick={goHome}>Or continue in the browser.</HomeLink>
        )}
      </WelcomeContainer>
    </Container>
  )
}

const Divider = styled.div<any>`
  height: 1px;
  width: 63px;
  background-color: ${colors.white25};
  margin: 35px auto 32px;
  ${(props: any): any => config(props).media.lg`
    ${(props: { isLarge: boolean }): any => {
      if (props.isLarge) {
        return `  margin: 40px auto 40px;`
      }
    }};
  `}
`
const Container = styled.div<any>`
  padding: ${(props: { isFullScreen: boolean }): string =>
    props.isFullScreen ? '0' : '63px 0'};
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const WelcomeContainer = styled.div<any>`
  max-width: 414px;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${(props: any): any => config(props).media.md`
    padding: 0;
  `}
`
const Header = styled.h1<any>`
  color: ${colors.sand};
  font-family: 'Queens Condensed Light';
  font-style: normal;
  font-weight: normal;
  line-height: 110%;
  margin-block: 0;
  padding: 0;
  -webkit-backface-visibility: hidden;
  font-smoothing: antialiased !important;
  transform: translateZ(0) scale(1, 1);
  z-index: 5;
  font-display: swap;
  margin: 16px 0;
  color: ${colors.sand};
  font-size: 36px;
  text-align: center;
  letter-spacing: 0.4px;
  ${(props: any): any => config(props).media.lg`
    ${(props: { isLarge: boolean }): any => {
      if (props.isLarge) {
        return `font-size: 45px; margin: 35px 0 25px;`
      }
    }};
  `}
`
const SubHeader = styled.p<any>`
  color: ${colors.sand};
  font-family: 'Good Sans Regular';
  font-style: normal;
  font-weight: normal;
  line-height: 150%;
  margin-block: 0;
  padding: 0;
  font-size: 14px;
  text-align: center;
  ${(props: any): any => config(props).media.lg`
    ${(props: { isLarge: boolean }): any => {
      if (props.isLarge) {
        return `font-size: 16px;`
      }
    }}
  `}
`
const SubHeaderAboveButton = styled.p<any>`
  display: flex;
  justify-content: center;
  font-family: 'Good Sans Bold';
  font-size: 16px;
  line-height: 150%;
  color: ${colors.sand};
  margin: 0 0 24px 0;
  padding: 0;
  ${(props: any): any => config(props).media.lg`
    ${(props: { isLarge: boolean }): any => {
      if (props.isLarge) {
        return `font-size: 18px;  margin: 0 0 34px 0;`
      }
    }};
  `}
`
const BadgeWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${(props: any): any => config(props).media.md`
    flex-direction: row;
    justify-content: center;
  `}
`
const HomeLink = styled.button<any>`
  cursor: pointer;
  background: none;
  border: none;
  display: flex;
  justify-content: center;
  font-family: 'Good Sans Light';
  font-size: 14px;
  line-height: 150%;
  color: ${colors.sand};
  margin: 24px 0 0;
  padding: 2px 10px;
  border-radius: 100px;
  &:hover {
    opacity: 0.5;
  }
  ${OutlineOnFocusVisible};
`
const BackgroundImageContainer = styled.div<any>`
  position: absolute;
  z-index: -1;
  top: 0;
  width: 100%;
  height: 100%;
`
